import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  MessageAlerte: {
    to: 'HomePageUI',
  },
  Settings: {
    code: async function(this: MenuItem) {
      return ;
    },
  },
  VwDeclarationsC: {
    to: 'VwDeclarationsCUI',
  }
}